// function activeStatus(e){
//   document.querySelectorAll('.custom-related-items .item').forEach((x) =>{
//     x.classList.remove('active');
//   });
//   e.classList.add('active');
//   document.querySelector('.active-layout-2 button.add-more').dataset.variantId = e.dataset.variantItem;
// }
// document.querySelector('.active-layout-2 button.add-more').addEventListener("click", (event) => {
//   //event.target.innerText = "Added!"
//   let formData = { 'items': [] };
//   let mainItem = {
//     'id': event.target.dataset.variantId,
//     'quantity': 1
//   }
//   formData.items.push(mainItem); 
  
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(formData)
//   })
//   .then(response => {
//     document.querySelector('#cart-notification').classList.add('active');
//     return response.json();
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
//   setTimeout(() => { window.location.href = "/cart"; }, 500);
// });
  



function activeStatus(e) {
  document.querySelectorAll('.custom-related-items .item').forEach((x) => {
    x.classList.remove('active');
  });
  e.classList.add('active');
  document.querySelector('.product-variant-id').value = e.dataset.variantItem;

}

// document.addEventListener("DOMContentLoaded", () => {
//   let addtocart_btn = document.querySelector('.active-layout-2 button.add-more');
//   let cart_notification = document.querySelector('#cart-notification');
//   let openSmartCart = false; // flag for delayed opening
//   let loader = document.querySelector('#cart-loader');

//   function showLoader() {
//     if (loader) loader.style.display = 'block';
//   }

//   function hideLoader() {
//     if (loader) loader.style.display = 'none';
//   }

//   if (addtocart_btn) {
//     addtocart_btn.removeAttribute("disabled");

//     addtocart_btn.addEventListener("click", (event) => {
//       let button = event.target;

//       let formData = { 'items': [] };

//       // Main item
//       formData.items.push({
//         'id': button.dataset.variantId,
//         'quantity': 1
//       });

//       // Upsells
//       document.querySelectorAll('.content-pack-wrapper input[type="checkbox"]:checked').forEach((checkbox) => {
//         formData.items.push({
//           'id': checkbox.value,
//           'quantity': 1
//         });
//       });

//       // Show loader immediately
//       showLoader();

//       // Add to cart
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       })
//       .then(response => {
//         if (cart_notification) {
//           cart_notification.classList.add('active');
//         }
//         return response.json();
//       })
//       .then(() => {
//         // If Rebuy ready, open SmartCart immediately
//         if (window.Rebuy && Rebuy.SmartCart) {
//           setTimeout(() => Rebuy.SmartCart.show(), 300);
//         } else {
//           // Otherwise, mark to open later
//           openSmartCart = true;
//         }
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//         hideLoader();
//       });
//     });
//   }

//   // Listen for Rebuy ready → open cart if pending
//   document.addEventListener('rebuy:smartcart.ready', () => {
//     if (openSmartCart && window.Rebuy && Rebuy.SmartCart) {
//       setTimeout(() => Rebuy.SmartCart.show(), 300);
//       openSmartCart = false;
//     }
//   });

//   // Listen for SmartCart drawer actually showing → hide loader
//   document.addEventListener('rebuy:smartcart.show', () => {
//     hideLoader();
//   });
// });